export default "/images/6890856b3ee95ba2040e0272e55d6951.avif";